import { Dispatch, SetStateAction } from 'react'
import { useTranslation } from 'react-i18next'

// local imports
import { IFavoriteLocations } from 'types/FavoritesType'
import useListActions from './use-list-actions'
import FavoriteIconButton from 'components/ui/FavoriteIconButton'
import { ListActionArea, ListItem, ReservationButton } from '../styled'
/* Assets */
import icon from 'assets/icons/location.svg'

interface ListItemProps {
  setList: Dispatch<SetStateAction<[] | IFavoriteLocations[]>>
  item: IFavoriteLocations
}

export default function FavoriteListItem({ item, setList }: ListItemProps) {
  const { t } = useTranslation()
  const locationAddress = `${item?.floor?.cityName}/${item?.floor?.districtName} ${item?.floor?.countryName}, ${item?.floor?.locationName}`

  /* Actions Hook (remove favorite - set reservation) */
  const { handleRemoveFavorite, handleSetReservation } = useListActions(setList)

  return (
    <ListItem key={item.id}>
      <div className="fav-icon">
        <img src={icon} width={24} height={24} alt="favorite-list-icon" />
      </div>

      <div className="fav-content">
        <div className="fav-name-loc">
          <span className="fav-name">{item?.floor?.locationName || '---'}</span>
          <span className="fav-location">{locationAddress}</span>
        </div>
        <div className="fav-block"> {item?.floor?.blockName || '---'}</div>
        <div className="fav-floor"> {item?.floor?.name || '---'}</div>
      </div>

      <ListActionArea>
        <ReservationButton onClick={handleSetReservation(item.floor)}>
          {t('buttons.book-reservation')}
        </ReservationButton>
        <FavoriteIconButton isFavorite onRemove={handleRemoveFavorite(item.floor.id)} />
      </ListActionArea>
    </ListItem>
  )
}
